import { render, staticRenderFns } from "./FiltersPopupSearch.vue?vue&type=template&id=e23f3820"
import script from "./FiltersPopupSearch.vue?vue&type=script&lang=js"
export * from "./FiltersPopupSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports